'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import React, { useState } from 'react';
import { Button, Collapse } from 'reactstrap';
import { MdExpandMore } from 'react-icons/md';
import FilterSummary from './FilterSummary';
import JobFacetFilters from './JobFacetFilters';
import { getI18nUtils } from '../i18n/i18n-utils';
import { facetGroupNames, getActiveFacetsFromSearchParams, JobsSearchResponse } from '../api/jobs';
import { Dictionaries } from '../i18n/i18n-config';
import { useSearchParams } from 'next/navigation';

function FacetSideNav({
  isOpen,
  toggle,
  jobData,
  dictionary,
}: {
  isOpen: boolean;
  toggle: () => void;
  jobData: JobsSearchResponse;
  dictionary: Partial<Dictionaries>;
}) {
  const searchParams = useSearchParams();
  const { formatMessage } = getI18nUtils(dictionary);
  const [filterSummaryOpen, setFilterSummaryOpen] = useState(true);

  const toggleFilterSummary = () => setFilterSummaryOpen((prev) => !prev);

  const jobCount = jobData?.count;

  const includeFilters = [
    'contractTypes',
    'division',
    'experiences',
    'jobDomains',
    'laborRegimes',
    'locations',
    'shifts',
    'workPlaceType',
    'student',
  ];

  const activeFilters: string[] = facetGroupNames
    .filter((gn) => includeFilters.includes(gn))
    .map((gn) => searchParams?.getAll(gn))
    .flat();
  const filterCount = activeFilters.length;

  return (
    <>
      {isOpen && <div onClick={toggle} id="facetSideNav-modal" className={`modal-backdrop fade ${isOpen ? 'show' : ''}`} />}
      <div id="facetSideNav" className={`${isOpen ? 'open' : 'closed'}`}>
        <button
          onClick={toggle}
          aria-label="Toggle navigation"
          type="button"
          className="navToggle ms-auto d-block text-secondary navbar-toggler py-2"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <h2 className="p-3 border-bottom text-capitalize">{formatMessage({ id: 'filters' })}</h2>
        <div className="ps-4">
          {filterCount > 0 && (
            <Button
              color="white"
              className="collapse-toggle px-0 w-100 d-flex justify-content-between h4 mt-3"
              onClick={toggleFilterSummary}
            >
              {formatMessage({ id: 'chosen_filters' })} ({filterCount})
              <MdExpandMore size="30" className="d-lg-none" />
            </Button>
          )}
          <Collapse isOpen={filterSummaryOpen}>
            <FilterSummary className="d-flex" label={false} dictionary={dictionary} />
          </Collapse>
          <JobFacetFilters facets={jobData.facets} dictionary={dictionary} />
        </div>
        {!!jobCount && jobCount > 0 && (
          <div id="sidenav-submit" className="position-sticky fixed-bottom">
            <Button className="w-100" onClick={toggle} color="primary">
              {formatMessage({ id: 'jobs-show-all' }, { jobCount })}
            </Button>
          </div>
        )}
      </div>
    </>
  );
}

export default FacetSideNav;
